module.exports = __webpack_public_path__ + "static/media/Xiaolongbao.e161ed98.png";